module.exports = __webpack_public_path__ + "static/1-e1c717fd7ce8627ba2dd7cbddd978a1a.jpeg";